module.exports = __webpack_public_path__ + "static/media/attach-circle.29a0d58e.svg";